interface Props {
  className?: string
}

function Ellipsis({ className = '' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43"
      height="3"
      fill="none"
      className={className}
    >
      <circle cx="1.5" cy="1.5" r="1.5" fill="currentColor" opacity="0.4" />
      <circle cx="9.5" cy="1.5" r="1.5" fill="currentColor" opacity="0.4" />
      <circle cx="17.5" cy="1.5" r="1.5" fill="currentColor" opacity="0.4" />
      <circle cx="25.5" cy="1.5" r="1.5" fill="currentColor" opacity="0.4" />
      <circle cx="33.5" cy="1.5" r="1.5" fill="currentColor" opacity="0.4" />
      <circle cx="41.5" cy="1.5" r="1.5" fill="currentColor" opacity="0.4" />
    </svg>
  )
}

export default Ellipsis
